var map = {
	"./ELEVATE.svg": 42685,
	"./Global-Challenges.svg": 82172,
	"./NFT-Awards.svg": 95760,
	"./QR.svg": 23611,
	"./Sport-to-Token.svg": 50343,
	"./UPDATE-Beta.svg": 10593,
	"./activ-coin.png": 95512,
	"./activities-icons/Ride.svg": 99530,
	"./activities-icons/Run.svg": 82798,
	"./activities-icons/Swim.svg": 67671,
	"./activities-icons/Walk.svg": 70040,
	"./add-provider.png": 6131,
	"./angle-down.svg": 18997,
	"./avatar-blank.svg": 5413,
	"./avatar1.png": 79231,
	"./avatar2.png": 65002,
	"./avatar3.png": 75664,
	"./avatar4.png": 11709,
	"./avatar5.png": 5355,
	"./avatar6.png": 82576,
	"./avatar7.png": 84856,
	"./close-icon.svg": 62424,
	"./coins-invite.svg": 5242,
	"./coins.png": 17096,
	"./conntect-check.svg": 50668,
	"./copy-icon.svg": 34748,
	"./dhealth-logo.svg": 75752,
	"./dhealth-network-logo.svg": 85476,
	"./disconnect.svg": 87895,
	"./dollar-sign.svg": 27325,
	"./event-timer.png": 62573,
	"./event-trophy.png": 75385,
	"./event.png": 3342,
	"./feedback.png": 56926,
	"./fitbit.png": 84985,
	"./fonts/Digit.ttf": 61282,
	"./fonts/Led.regular.ttf": 29778,
	"./fonts/Technology-Bold.ttf": 26698,
	"./fonts/Technology-BoldItalic.ttf": 1736,
	"./fonts/Technology-Italic.ttf": 6175,
	"./fonts/Technology.ttf": 32933,
	"./fonts/Wallpoet-Regular.ttf": 37740,
	"./fonts/bold-led-board-7.regular.ttf": 65594,
	"./footballbg.jpg": 20886,
	"./friend1.png": 40388,
	"./friend2.png": 15293,
	"./garmin.png": 14557,
	"./gift-icon.svg": 72287,
	"./icons/Activity-icon-header.svg": 83855,
	"./icons/Apple.svg": 5707,
	"./icons/Home.svg": 23413,
	"./icons/Plus-sign.svg": 99998,
	"./icons/Running.svg": 15146,
	"./icons/Yoga.svg": 33689,
	"./icons/arrow-back.svg": 3784,
	"./icons/chain-icon.svg": 28763,
	"./icons/close-icon.svg": 83997,
	"./icons/coins.svg": 53085,
	"./icons/info-icon.svg": 33309,
	"./icons/info-tip.svg": 98571,
	"./icons/like-icon.svg": 61933,
	"./icons/logout.svg": 52990,
	"./icons/menu-activity.svg": 9912,
	"./icons/menu-closed.svg": 41586,
	"./icons/menu-dashboard.svg": 53938,
	"./icons/menu-events.svg": 30786,
	"./icons/menu-open.svg": 78330,
	"./icons/menu-rewards.svg": 79514,
	"./icons/menu-settings.svg": 94649,
	"./icons/play-icon.svg": 28008,
	"./icons/refer-earn.svg": 69102,
	"./login-hero.png": 92662,
	"./login-slides/slide-1.jpg": 93935,
	"./login-slides/slide-2.jpg": 80649,
	"./medal1.svg": 67931,
	"./medal2.svg": 71040,
	"./medal3.svg": 64189,
	"./medal4.svg": 23385,
	"./no-integrations-bg.svg": 8998,
	"./profile-avatar.png": 89006,
	"./progress-medal.png": 35583,
	"./progressbar-bg.png": 45562,
	"./promotion.svg": 83572,
	"./provided.svg": 76831,
	"./refer-bg.svg": 3081,
	"./runningbg.jpg": 39187,
	"./select-open.svg": 54913,
	"./share-icon.svg": 94353,
	"./share/discord.svg": 78709,
	"./share/facebook.svg": 78133,
	"./share/linkedin.svg": 72123,
	"./share/telegram.svg": 74315,
	"./share/twitter.svg": 80467,
	"./share/whatsapp.svg": 86026,
	"./star-badge.png": 99624,
	"./strava.png": 82650,
	"./tip-arrow.svg": 57953,
	"./user-avatar.png": 10211,
	"./workout.svg": 2037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;